export default class LoaderPopup {

	static show() {
		this.__animationReset(true, () => {
			this.__animationStart();
		});
	}

	static hide() {
		this.__animationReset(true, () => {
			clearInterval(this.animationInterval);
		});
	}

	// Private methods are prefixed with __

	static __animationReset(first, callback) {
		let logoPaths = document.querySelectorAll('.homie_logo.loader path');
		if(logoPaths.length) {
			if (first) {
				logoPaths[0].style.transform = 'translateX(-62px)';
				logoPaths[0].style.animation = 'moveRectangleBack .1s linear both';
			} else {
				logoPaths[0].style.transform = 'translateX(0)';
				logoPaths[0].style.animation = 'moveRectangle .8s linear both';
			}
	
			logoPaths[2].style.fillOpacity = 0;
			logoPaths[3].style.fillOpacity = 0;
			logoPaths[4].style.fillOpacity = 0;
			logoPaths[5].style.fillOpacity = 0;
			if (first) {
				callback();
			}
    }
  }

	static __animationStart() {
		let flipAnimation = true;
		this.__animationReset(true, () => {
			this.__animation(true);
			this.animationInterval = setInterval(() => {
				if (flipAnimation) {
					this.__animationReset(false);
				} else {
					this.__animation(false);
				}
				flipAnimation = !flipAnimation;
			}, 950);
		})
	}

	static __animation(first) {
		let letters = ['rectangle', 'o', 'm', 'i', 'e', 'end'];
		let timeLetter = first ? 165 : 150;
		let timeRectangle = '.7s';
		let logoPaths = document.querySelectorAll('.homie_logo.loader path');
		if(logoPaths.length) {
      logoPaths[0].style.transform = 'translateX(-62px)';
      logoPaths[0].style.animation = 'moveRectangleBack ' + timeRectangle + ' linear both';
      letters.forEach(function (l, i) {
        setTimeout(function () {
          if (l !== 'rectangle' && l !== 'end') {
            logoPaths[i + 1].style.fillOpacity = 1
          }
          if (l === 'end') {
            logoPaths[2].style.fillOpacity = 0;
            logoPaths[3].style.fillOpacity = 0;
            logoPaths[4].style.fillOpacity = 0;
            logoPaths[5].style.fillOpacity = 0;
          }
        }, (i + 1) * timeLetter);
      })
    }
	}
}
